var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "map-btn map-shadow",
      class: { "map-btn-disable": _vm.is_disabled },
      attrs: { id: "map-btn" },
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.$emit("click")
        }
      }
    },
    [
      _c("span", {
        staticClass: "map-btn-icon",
        class: "map-btn-icon-" + _vm.name
      }),
      _vm._v(" "),
      _vm._t("map-btn-text"),
      _vm._v(" "),
      _vm._t("map-btn-menu")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }